import { AuthProvider } from "@/auth/AuthProvider";
import { ConfigProvider } from "antd";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { themeConfig, themeLocale } from "./config/themeConfig";
import AppRoutes from "./routes";

export const App = () => {
  return (
    <ConfigProvider locale={themeLocale} theme={themeConfig}>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster closeButton position="bottom-left" />
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
};
